<script setup lang="ts">
import { ref, onMounted, nextTick } from 'vue';
import useScrollAnimation from './animations/scroll-animation';

const { createTweenTo } = useScrollAnimation();

export interface Props {
  value: number;
  duration: number;
}
const props = withDefaults(defineProps<Props>(), {
  value: 0,
  duration: 1000,
});
const displayValue = ref<number>(0);
const startAnimation = () => {
  const startValue = 0;
  const endValue = props.value;
  const rangeValue = endValue - startValue;
  let currentValue = startValue;
  const increment = endValue > startValue ? 1 : -1;
  const stepTime = Math.abs(Math.floor(props.duration / rangeValue));
  const timer = setInterval(() => {
    currentValue += increment;
    displayValue.value = currentValue;
    if (currentValue === endValue) {
      clearInterval(timer);
    }
  }, stepTime);

  return () => clearInterval(timer);
};

onMounted(() => {
  createTweenTo(`.counter`, {
    scrollTrigger: {
      invalidateOnRefresh: true,
      trigger: `.counter`,
      start: `top 75%`,
      end: `bottom bottom`,
      onEnter: startAnimation,
      id: `counter`,
      markers: false,
    },
  });
});
</script>

<template>
  <span class="counter">
    {{ displayValue }}
  </span>
</template>
